<template>
    <div
        ref="wrapper"
        class="swiper-container overflow-hidden pt-1"
        role="region"
        :aria-label="$t('a11y.bird_sound_gallery')"
    >
        <div class="container lg:hidden">
            <div class="separator-border-top-line"></div>
        </div>
        <div ref="swiper" class="container swiper swiper--audio grid grid-cols-1">
            <h2 class="order-1 header-2 sm:whitespace-nowrap sm:absolute sm:-top-1">
                <T t="bird_friendly_learning_trail.listen_to_their_singing" />
            </h2>
            <div class="order-3 sm:order-2 carousel-pagination-block container relative">
                <nav class="flex items-center justify-center sm:justify-end" :aria-label="$t('a11y.gallery_stepper')">
                    <button ref="prevBtn" class="swiper-button-prev"></button>
                    <span class="gallery-pagination-counter">01</span>
                    <div ref="pagination" class="swiper-pagination"></div>
                    <span class="gallery-pagination-counter">{{ String(items.length).padStart(2, '0') }}</span>
                    <button ref="nextBtn" class="swiper-button-next"></button>
                </nav>
            </div>
            <div class="order-2 sm:order-3 swiper-wrapper mb-8 sm:mb-0 mt-8 sm:mt-12">
                <div v-for="(item, i) in items" :key="`gallery-image-${i}`" class="swiper-slide text-center">
                    <AudioPlaybackCard
                        :name="item.name"
                        :latin-name="item.latin_name"
                        :img="item.media.image ? item.media.image.sm : ''"
                        :audio="item.media.audio"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AudioPlaybackCard from '@/components/Cards/AudioPlaybackCard/AudioPlaybackCard.vue';

export default {
    name: 'AudioPlayerCarousel',
    components: {
        AudioPlaybackCard,
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            carousel: null,
        };
    },
    mounted() {
        this.carousel = new this.$swiper(this.$refs.swiper, {
            spaceBetween: 16,
            slidesPerView: 1.1,
            centeredSlides: false,
            loop: false,
            navigation: {
                nextEl: this.$refs.nextBtn,
                prevEl: this.$refs.prevBtn,
            },
            pagination: {
                el: this.$refs.pagination,
                clickable: true,
                bulletElement: 'button',
            },
            breakpoints: {
                480: {
                    spaceBetween: 30,
                    slidesPerView: 2.2,
                },
                640: {
                    spaceBetween: 30,
                    slidesPerView: 3,
                },
                1024: {
                    spaceBetween: 30,
                    slidesPerView: 4,
                },
                1920: {
                    spaceBetween: 30,
                    slidesPerView: 4,
                },
            },
            a11y: {
                containerMessage: this.$t('carousel.a11y.container_message_birds'),
                paginationBulletMessage: this.$t('carousel.a11y.pagination_bullet_message'),
                firstSlideMessage: this.$t('carousel.a11y.first_slide_message'),
                lastSlideMessage: this.$t('carousel.a11y.last_slide_message'),
                nextSlideMessage: this.$t('carousel.a11y.next_slide_message'),
                prevSlideMessage: this.$t('carousel.a11y.prev_slide_message'),
            },
        });
    },
    beforeDestroy() {
        this.carousel.destroy();
    },
};
</script>

<style>
.swiper.swiper--audio {
    overflow: visible;
}
</style>
